import CostList from 'components/common/CostList';
import CostListItem from 'components/common/CostListItem';
import React, { FocusEvent, useEffect } from 'react';
import { connect } from 'react-redux';
import { AppState } from 'store';
import { getMonthlyLivingCost, getMonthlyLoanCost } from 'store/tilstandsrapportEntities/tilstandsrapport/selectors';
import { doFetchPersonalFinance, doUpdatePersonalFinance } from 'store/user/personalFinance/actions';
import { getPersonalFinanceFormValuesLength } from 'store/user/personalFinance/selectors';
import { PersonalFinance, PersonalFinanceActionCreators } from 'store/user/personalFinance/types';
import CollapseSection from '../CollapseSection';
import EditableInput from '../EditableInput';
import FormItem from '../FormItem';
import styles from '../LoanCalculator/styles.scss';

interface Props {
  tilstandsrapportId: string;
}

interface StateProps {
  personalFinance: PersonalFinance;
  personalFinanceValuesLength?: number;
  monthlyLivingCost: number;
  monthlyLoanCost: number;
}

interface DispatchProps {
  doFetchPersonalFinance: Function;
  doUpdatePersonalFinance: Function;
}

const EconomyCalculator = ({
  personalFinance,
  personalFinanceValuesLength,
  monthlyLivingCost,
  monthlyLoanCost,
  doFetchPersonalFinance: fetchPersonalFinance,
  doUpdatePersonalFinance: updatePersonalFinance,
}: Props & StateProps & DispatchProps): JSX.Element => {
  useEffect(() => {
    fetchPersonalFinance();
  }, []);

  const { salary, otherInsurance, saving, otherPayments } = personalFinance;
  return (
    <CollapseSection
      className={styles.section}
      title="Din økonomi"
      subtitle={`${personalFinanceValuesLength} av ${Object.keys(personalFinance).length}`}
    >
      <FormItem label="Utbetalt lønn pr. måned" className={styles.formItem}>
        <EditableInput
          placeholder="Utbetalt lønn pr. måned"
          value={salary && salary.toString()}
          type="number"
          prefix=",-"
          onBlur={(e: FocusEvent<HTMLInputElement>): PersonalFinanceActionCreators =>
            updatePersonalFinance('salary', e.target.value)
          }
        />
      </FormItem>

      <FormItem label="Andre forsikringer pr. måned" className={styles.formItem}>
        <EditableInput
          placeholder="Andre forsikringer pr. måned"
          value={otherInsurance && otherInsurance.toString()}
          type="number"
          prefix=",-"
          onBlur={(e: FocusEvent<HTMLInputElement>): PersonalFinanceActionCreators =>
            updatePersonalFinance('otherInsurance', e.target.value)
          }
        />
      </FormItem>

      <FormItem label="Sparing pr. måned" className={styles.formItem}>
        <EditableInput
          placeholder="Sparing pr. måned"
          value={saving && saving.toString()}
          type="number"
          prefix=",-"
          onBlur={(e: FocusEvent<HTMLInputElement>): PersonalFinanceActionCreators =>
            updatePersonalFinance('saving', e.target.value)
          }
        />
      </FormItem>

      <FormItem label="Andre utgifter pr. måned" className={styles.formItem}>
        <EditableInput
          placeholder="Andre utgifter pr. måned"
          value={otherPayments && otherPayments.toString()}
          type="number"
          prefix=",-"
          onBlur={(e: FocusEvent<HTMLInputElement>): PersonalFinanceActionCreators =>
            updatePersonalFinance('otherPayments', e.target.value)
          }
        />
      </FormItem>
      <CostList>
        <CostListItem description="Lån pr. måned" amount={monthlyLoanCost} />
        <CostListItem description="Faste utgifter bolig pr. måned" amount={monthlyLivingCost} />
      </CostList>
    </CollapseSection>
  );
};

const mapStateToProps = (state: AppState, ownProps: Props): StateProps => ({
  personalFinance: state.user.personalFinance,
  personalFinanceValuesLength: getPersonalFinanceFormValuesLength(state),
  monthlyLivingCost: getMonthlyLivingCost(state, ownProps.tilstandsrapportId),
  monthlyLoanCost: getMonthlyLoanCost(state, ownProps.tilstandsrapportId),
});

export default connect(
  mapStateToProps,
  { doFetchPersonalFinance, doUpdatePersonalFinance },
)(EconomyCalculator);
